module.exports = __webpack_public_path__ + "static/what-to-wear-where-bd3d2ba1d4c6593206fea2f467b7a146.jpg";